export const getSectionLevel = (sections: any[]) =>
    sections?.[0]?.level1 ||
    sections?.[0]?.level2 ||
    sections?.[0]?.level3 ||
    sections?.[0]?.level4;
